module.exports = __webpack_public_path__ + "static/3-layer3-31bb96f324fad87739c14839438af0b2.svg";